import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, isPushSubscribed, subscribeToPush, unsubscribeFromPush } from "@/lib/push";

export function PushToggle() {
  const [supported] = useState(pushSupported());
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (supported) isPushSubscribed().then(setOn).catch(() => {});
  }, [supported]);

  if (!supported) {
    return (
      <div className="flex items-center gap-3 bg-[#121212] border border-white/10 rounded-sm p-4 text-sm text-neutral-400">
        <BellOff className="h-5 w-5 text-neutral-500" /> Les notifications push ne sont pas disponibles sur cet appareil (iPhone : ajoutez d'abord l'app à l'écran d'accueil).
      </div>
    );
  }

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await unsubscribeFromPush(); setOn(false); toast.success("Notifications désactivées"); }
      else { await subscribeToPush(); setOn(true); toast.success("Notifications activées — vous serez prévenu des nouveautés"); }
    } catch (err) {
      toast.error(err.message || "Action impossible");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="push-toggle" className="flex flex-wrap items-center justify-between gap-3 bg-[#121212] border border-white/10 rounded-sm p-4">
      <div className="flex items-center gap-3">
        <Bell className={`h-5 w-5 ${on ? "text-[#C5A059]" : "text-neutral-500"}`} />
        <div>
          <p className="text-sm font-medium text-white">Notifications push</p>
          <p className="text-xs text-neutral-500">Recevez une alerte instantanée sur cet appareil dès qu'un véhicule correspond.</p>
        </div>
      </div>
      <Button data-testid="push-toggle-btn" onClick={toggle} disabled={busy} size="sm" className={on ? "bg-white/5 border border-white/15 text-white hover:bg-white/10 rounded-sm" : "bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm"}>
        {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{on ? "Désactiver" : "Activer"}
      </Button>
    </div>
  );
}
